import { BannerRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * bannerOnUpdateData - Function that updates on database an existing banner by id
 * /banners/{id}
 * method PUT
 * @async-function
 */
const bannerOnUpdateData = async (token: string, model: BannerRequestType, id: number) => {
    const response = await api.put(
        `/banners/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default bannerOnUpdateData;
